import { Action } from "@reduxjs/toolkit";
import { Rootstate } from "../../store";


const defaultState = {
    zoom: 1,
};

interface GridReducerAction extends Action {
  value: number
}

const zoomReducer = (state = defaultState, action: GridReducerAction): typeof defaultState => {
    switch (action.type) {
    case 'ZOOM/SET_ZOOM':
        return {
            ...state,
            zoom: action.value,
        };
    default:
        return state;
    }
};

export const zoomSelector = (state: Rootstate) => state.zoom;

export default zoomReducer;

